import { useQuery } from "react-query";
import { getUserProfile } from "../api/user/profile";
import useAxiosPrivate from "./useAxiosPrivate";
import { useAppContext } from "../context/appContext";
import { can, describeUser, homePath } from "../lib/permissions";

/**
 * The logged-in user, their permission level and what they may do (see lib/permissions).
 * can("manageUnit", unitId) etc. The API enforces the same rules; this only decides what the UI shows.
 */
export default function useCurrentUser({ enabled = true } = {}) {
	const { axiosPrivate } = useAxiosPrivate();
	const { data, isLoading } = useQuery("current-user", () => getUserProfile(axiosPrivate), { staleTime: 5 * 60 * 1000, enabled });
	const userUnits = useAppContext()?.items?.userUnits;
	const described = describeUser(data?.id ? data : null, userUnits);

	return {
		...described,
		isLoading: enabled && isLoading,
		can: (permission, ...args) => can(described, permission, ...args),
		homePath: homePath(described),
	};
}
